export interface StrapiItem {
  id: number;
  documentId?: string;
  [key: string]: any;
}

export interface StrapiState {
  [modelName: string]: {
    data?: any[];
    loading?: boolean;
    error?: string | null;
    lastAddedId?: number | null;
    lastDocId?: string | null;
    lastAddedCreatorId?: string | null;
    actionByContext?: {
      data: any[];
      loading: boolean;
      error: string | null;
    };
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export enum StrapiActionTypes {
  FETCH_REQUEST_VPO = 'strapi/FETCH_REQUEST_VPO',
  FETCH_SUCCESS_VPO = 'strapi/FETCH_SUCCESS_VPO',
  FETCH_FAILURE_VPO = 'strapi/FETCH_FAILURE_VPO',
  ADD_REQUEST_VPO = 'ADD_REQUEST_VPO',
  ADD_SUCCESS_VPO = 'ADD_SUCCESS_VPO',
  ADD_FAILURE_VPO = 'ADD_FAILURE_VPO',
  SET_LAST_ADDED_ID_VPO = 'SET_LAST_ADDED_ID_VPO',
  UPDATE_REQUEST_VPO = 'UPDATE_REQUEST_VPO',
  UPDATE_SUCCESS_VPO = 'UPDATE_SUCCESS_VPO',
  UPDATE_FAILURE_VPO = 'UPDATE_FAILURE_VPO',
  DELETE_REQUEST_VPO = 'DELETE_REQUEST_VPO',
  DELETE_SUCCESS_VPO = 'DELETE_SUCCESS_VPO',
  DELETE_FAILURE_VPO = 'DELETE_FAILURE_VPO',
  SET_LAST_DOC_ID_VPO = 'SET_LAST_DOC_ID_VPO',
  FETCH_ACTION_BY_CONTEXT_REQUEST_VPO = 'FETCH_ACTION_BY_CONTEXT_REQUEST_VPO',
  FETCH_ACTION_BY_CONTEXT_SUCCESS_VPO = 'FETCH_ACTION_BY_CONTEXT_SUCCESS_VPO',
  FETCH_ACTION_BY_CONTEXT_FAILURE_VPO = 'FETCH_ACTION_BY_CONTEXT_FAILURE_VPO',
  FETCH_INCONSISTENCIES_BY_ACTION_REQUEST_VPO = 'FETCH_INCONSISTENCIES_BY_ACTION_REQUEST_VPO',
  FETCH_INCONSISTENCIES_BY_ACTION_SUCCESS_VPO = 'FETCH_INCONSISTENCIES_BY_ACTION_SUCCESS_VPO',
  FETCH_INCONSISTENCIES_BY_ACTION_FAILURE_VPO = 'FETCH_INCONSISTENCIES_BY_ACTION_FAILURE_VPO',
  FETCH_ACTIONS_ONLY_REQUEST_VPO = 'FETCH_ACTIONS_ONLY_REQUEST_VPO',
  FETCH_ACTIONS_ONLY_SUCCESS_VPO = 'FETCH_ACTIONS_ONLY_SUCCESS_VPO',
  FETCH_ACTIONS_ONLY_FAILURE_VPO = 'FETCH_ACTIONS_ONLY_FAILURE_VPO',
  CLEAR_INCONSISTENCIES_BY_ACTION_VPO = 'CLEAR_INCONSISTENCIES_BY_ACTION_VPO',
}

export interface FetchRequestAction {
  type: StrapiActionTypes.FETCH_REQUEST_VPO;
  payload: {
    modelName: string;
    params?: any;
    pagination?: {
      page: number;
      pageSize: number;
    };
  };
}

export interface FetchSuccessAction {
  type: StrapiActionTypes.FETCH_SUCCESS_VPO;
  payload: {
    modelName: string;
    data: StrapiItem[];
    pagination?: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export interface FetchFailureAction {
  type: StrapiActionTypes.FETCH_FAILURE_VPO;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface AddRequestAction {
  type: StrapiActionTypes.ADD_REQUEST_VPO;
  payload: {
    modelName: string;
    data: any;
    creatorId?: string;
  };
}

export interface AddSuccessAction {
  type: StrapiActionTypes.ADD_SUCCESS_VPO;
  payload: {
    modelName: string;
    data: StrapiItem;
    creatorId?: string;
  };
}

export interface AddFailureAction {
  type: StrapiActionTypes.ADD_FAILURE_VPO;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface SetLastAddedIdAction {
  type: StrapiActionTypes.SET_LAST_ADDED_ID_VPO;
  payload: {
    modelName: string;
    id: number | null;
  };
}

export interface UpdateRequestAction {
  type: StrapiActionTypes.UPDATE_REQUEST_VPO;
  payload: {
    modelName: string;
    documentId: string;
    data: any;
  };
}

export interface UpdateSuccessAction {
  type: StrapiActionTypes.UPDATE_SUCCESS_VPO;
  payload: {
    modelName: string;
    data: StrapiItem;
  };
}

export interface UpdateFailureAction {
  type: StrapiActionTypes.UPDATE_FAILURE_VPO;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface DeleteRequestAction {
  type: StrapiActionTypes.DELETE_REQUEST_VPO;
  payload: {
    modelName: string;
    documentId: string;
  };
}

export interface DeleteSuccessAction {
  type: StrapiActionTypes.DELETE_SUCCESS_VPO;
  payload: {
    modelName: string;
    documentId: string;
  };
}

export interface DeleteFailureAction {
  type: StrapiActionTypes.DELETE_FAILURE_VPO;
  payload: {
    modelName: string;
    error: string;
  };
}

export interface SetLastDocIdAction {
  type: StrapiActionTypes.SET_LAST_DOC_ID_VPO;
  payload: {
    modelName: string;
    documentId: string | null;
  };
}

export interface FetchActionByContextRequestAction {
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST_VPO;
  payload: {
    modelName: string;
    context: any;
  };
}

export interface FetchActionByContextSuccessAction {
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_SUCCESS_VPO;
  payload: {
    data: any[];
  };
}

export interface FetchActionByContextFailureAction {
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_FAILURE_VPO;
  payload: {
    error: string;
  };
}

export interface FetchInconsistenciesByActionRequestAction {
  type: StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_REQUEST_VPO;
  payload: {
    actionId: number;
  };
}

export interface FetchInconsistenciesByActionSuccessAction {
  type: StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_SUCCESS_VPO;
  payload: {
    data: any[];
  };
}

export interface FetchInconsistenciesByActionFailureAction {
  type: StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_FAILURE_VPO;
  payload: {
    error: string;
  };
}

export interface FetchActionsOnlyRequestAction {
  type: StrapiActionTypes.FETCH_ACTIONS_ONLY_REQUEST_VPO;
  payload: {
    factory: number;
    month: number;
    year: string;
    column: number;
  };
}

export interface FetchActionsOnlySuccessAction {
  type: StrapiActionTypes.FETCH_ACTIONS_ONLY_SUCCESS_VPO;
  payload: {
    actions: any[];
  };
}

export interface FetchActionsOnlyFailureAction {
  type: StrapiActionTypes.FETCH_ACTIONS_ONLY_FAILURE_VPO;
  payload: {
    error: string;
  };
}

export interface ClearInconsistenciesByActionAction {
  type: StrapiActionTypes.CLEAR_INCONSISTENCIES_BY_ACTION_VPO;
}

export type StrapiActions =
  | FetchRequestAction
  | FetchSuccessAction
  | FetchFailureAction
  | AddRequestAction
  | AddSuccessAction
  | AddFailureAction
  | SetLastAddedIdAction
  | UpdateRequestAction
  | UpdateSuccessAction
  | UpdateFailureAction
  | DeleteRequestAction
  | DeleteSuccessAction
  | DeleteFailureAction
  | SetLastDocIdAction
  | FetchActionByContextRequestAction
  | FetchActionByContextSuccessAction
  | FetchActionByContextFailureAction
  | FetchInconsistenciesByActionRequestAction
  | FetchInconsistenciesByActionSuccessAction
  | FetchInconsistenciesByActionFailureAction
  | FetchActionsOnlyRequestAction
  | FetchActionsOnlySuccessAction
  | FetchActionsOnlyFailureAction
  | ClearInconsistenciesByActionAction;
